import React, { useCallback } from 'react'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import TextInput from 'components/Common/Form/Input/TextInput'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import { formToObject } from 'lib/forms/formToObject'
import Clickable from 'components/Common/Clickable'
import config from 'constants/config'

function AuthTab() {
  const onSetAccessToken = useCallback<React.FormEventHandler<HTMLFormElement>>(e => {
    e.preventDefault()
    const { accessToken } = formToObject(e.currentTarget)
    if (accessToken) {
      (e.currentTarget.elements.namedItem('accessToken') as HTMLInputElement).value = ''
      window.location.reload()
      document.cookie = `ssr_access_token=${accessToken}; expires=Wed, 11 Jul 2040 00:00:00 GMT; path=/; domain=${document.domain}`
      document.cookie = `access_token=${accessToken}; expires=Wed, 11 Jul 2040 00:00:00 GMT; path=/; domain=${config.API_HOST}`
    }
  }, [])

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Auth</Heading>

      <form onSubmit={onSetAccessToken}>
        <TextInput
          label="Set access token"
          helpText="Useful for logging into prod via local CP. Will reload the page."
          name="accessToken"
          required
          endIcon={<Clickable type="submit"><LineArrowRightIcon /></Clickable>}
        />
      </form>
    </VerticalSpacer>
  </Pane>
}

export default AuthTab
